import OrderOptimizerDetailsOtherRequest from "../../../../api/raily/order-optimizer/details/other/order-optimizer-details-other.request";
import OrderOptimizerDetailsOtherParams from "./order-optimizer-details-other-params";

const create = (
  params: OrderOptimizerDetailsOtherParams,
): OrderOptimizerDetailsOtherRequest => {
  return {
    optimizationId: params.optimizationId,
    taxiDriverAssociationId: params.taxiDriverAssociationId,
    excludedOrders: params.excludedOrders,
  };
};

const orderOptimizerDetailsOtherParamsFactory = {
  create,
};

export default orderOptimizerDetailsOtherParamsFactory;
